import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Wrapper, ModalContainer } from './styled';
export const Modal = ({ children, show, onOpen = () => { }, onClose = () => { }, styles, }) => {
    // TODO: move MODAL to PORTAL
    const modalRef = useRef(null);
    useEffect(() => {
        if (show)
            onOpen();
    }, [show]);
    const closeHandler = (event) => {
        if (event.target === modalRef.current)
            onClose();
    };
    return show ? (_jsx(Wrapper, { ref: modalRef, onClick: closeHandler, children: _jsx(ModalContainer, { style: styles, children: children }) })) : null;
};
